const translations = {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.services": "Services",
  "nav.calendar": "Calendar",
  "nav.sermons": "Sermons",
  "nav.resources": "Resources",
  "nav.news": "News",
  "nav.contact": "Contact",
  "nav.donate": "Donate",

  // Hero Section
  "hero.title": "Saint Mina & Pope Cyril VI",
  "hero.subtitle": "Coptic Orthodox Church",
  "hero.tagline": "Rooted in ancient faith in a modern world",
  "hero.location": "Serving Montreal's North Shore",
  "hero.joinUs": "Join Us This Sunday",
  "hero.learnMore": "Learn More about us",

  // Liturgy Schedule
  "liturgy.sunday": "Sunday",
  "liturgy.wednesday": "Wednesday",
  "liturgy.friday": "Friday",
  "liturgy.saturday": "Saturday",
  "liturgy.satVespers": "Sat Vespers",
  "liturgy.weeklySchedule": "Weekly Schedule",
  "liturgy.divineLiturgyTimes": "Divine Liturgy Times",
  "liturgy.joinEucharist": "Join us for the Holy Eucharist throughout the week",
  "liturgy.divineLiturgy": "Divine Liturgy",
  "liturgy.saturdayEvening": "Saturday Evening",
  "liturgy.vespersMidnight": "Vespers & Midnight Praises (Tasbeha)",
  "liturgy.viewFullCalendar": "View Full Calendar",
  "liturgy.thisWeekLiturgies": "This Week's Liturgies",
  "liturgy.thisWeekSchedule": "This Week's Schedule",
  "liturgy.liveFromGoogleCalendar": "Live from Google Calendar",
  "liturgy.loadingSchedule": "Loading liturgy schedule…",
  "liturgy.time": "Time",
  "liturgy.language": "Language",
  "liturgy.location": "Location",
  "liturgy.divineService": "Divine Service",

  // Services Section
  "services.title": "Our Services",
  "services.subtitle": "Join us for worship, spiritual growth, and fellowship",
  "services.confession": "Confession",
  "services.confessionDesc": "Spiritual guidance and reconciliation",
  "services.sundaySchool": "Sunday School",
  "services.sundaySchoolDesc": "Faith education for all ages",
  "services.preschoolCoptic": "Pre-school Coptic",
  "services.preschoolCopticDesc": "Teaching our sacred language",
  "services.holyLiturgy": "Holy Liturgy",
  "services.holyLiturgyTime": "Sunday 8:00 – 11:30 AM",
  "services.choir": "Choir",
  "services.choirDesc": "Sacred hymns and melodies",
  "services.bibleStudy": "Bible Study",
  "services.bibleStudyDesc": "Deepen your faith through scripture",
  "services.viewFullSchedule": "View Full Schedule",

  // Church Leaders
  "leaders.title": "Our Coptic Orthodox Church",
  "leaders.subtitle": "Led by faithful servants dedicated to spiritual guidance",
  "leaders.popeTawadros": "His Holiness Pope Tawadros II",
  "leaders.popeTawadrosTitle": "118th Pope of Alexandria & Patriarch of the See of Saint Mark",
  "leaders.popeTawadrosDesc": "His Holiness leads the Coptic Orthodox Church worldwide with wisdom and devotion, continuing the apostolic succession from Saint Mark.",
  "leaders.bishopBoulos": "His Grace Bishop Boulos",
  "leaders.bishopBoulosTitle": "Bishop of the diocese of Ottawa, Montreal & Eastern Canada",
  "leaders.bishopBoulosDesc": "His Grace serves with dedication and love, providing spiritual guidance and pastoral care to our community.",
  "leaders.fatherAnthony": "Father Anthony Micheal",
  "leaders.fatherAnthonyTitle": "Priest at Saint Mina & Pope Cyril VI Coptic Orthodox Church",
  "leaders.fatherAnthonyDesc": "Father Anthony serves our parish with compassion and dedication, shepherding our community in faith and love.",

  // Featured Sections
  "featured.recentSermons": "Recent Sermons",
  "featured.sermonsDesc": "Listen to inspiring messages from our clergy",
  "featured.viewAllSermons": "View All Sermons",
  "featured.upcomingEvents": "Upcoming Events",
  "featured.eventsDesc": "Join us for fellowship and community activities",
  "featured.viewAllEvents": "View All Events",
  "featured.photoGallery": "Photo Gallery",
  "featured.galleryDesc": "Sacred icons and community moments",
  "featured.viewGallery": "View Gallery",

  // CTA Section
  "cta.supportMission": "Support Our Mission",
  "cta.supportDesc": "Your generous contributions help us continue our ministry and serve our community",
  "cta.makeDonation": "Make a Donation",

  // Footer
  "footer.quickLinks": "Quick Links",
  "footer.contact": "Contact",
  "footer.followUs": "Follow Us",
  "footer.rights": "All rights reserved.",
  "footer.tagline": "Rooted in the ancient Orthodox faith\u00a0Serving Montreal's North Shore.",
  "footer.church": "Church",
  "footer.resources": "Resources",
  "footer.connect": "Connect",
  "footer.resourcesHub": "Resources Hub",
  "footer.baptismForm": "Baptism Form",
  "footer.marriageForm": "Marriage Form",
  "footer.funeralForm": "Funeral Form",
  "footer.eventBooking": "Event Booking",
  "footer.membershipForm": "Membership",
  "footer.engagementForm": "Engagement Form",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  "footer.copyright": "© 2026 Saint Mina & Pope Cyril VI Coptic Orthodox Church. All rights reserved.",

  // ── Home Page ──
  "home.seasonalPosts": "Seasonal Posts",
  "home.seasonalPostsDesc": "In-depth reflections on the seasons and celebrations of the Coptic Orthodox liturgical year",
  "home.currentlyObserving": "Currently Observing",
  "home.daysRemaining": "days remaining",
  "home.dayRemaining": "day remaining",
  "home.nextFeast": "Next Feast",
  "home.daysAway": "days away",
  "home.dayAway": "day away",
  "home.fastingSeason": "Fasting Season",
  "home.holyWeek": "Holy Week",
  "home.upcomingFeast": "Upcoming Feast",
  "home.currentSeason": "Current Season",
  "home.liturgicalSeason": "Liturgical Season",
  "home.readFullArticle": "Read Full Article",
  "home.viewAllNews": "View All News",
  "home.divineService": "Divine Service",
  "home.time": "Time",
  "home.language": "Language",
  "home.location": "Location",
  "home.viewFullCalendar": "View Full Calendar",
  "home.liveFromGoogleCalendar": "Live from Google Calendar",
  "home.loadingLiturgySchedule": "Loading liturgy schedule…",
  "home.thisWeekLiturgies": "This Week's Liturgies",
  "home.thisWeekSchedule": "This Week's Schedule",
  "home.close": "Close",
  "home.openOnYouTube": "Open on YouTube",
  "home.stayConnected": "Stay Connected",
  "home.followUsSocial": "Follow Us on Social Media",
  "home.socialDesc": "Stay connected with our latest moments, reflections, and community highlights across all our platforms.",
  "home.spiritualGuidance": "Spiritual Guidance",
  "home.liveStreaming": "Live Streaming",
  "home.sermonsDesc": "Listen to inspiring messages and teachings from our clergy",
  "home.latest": "Latest",
  "home.viewAllOnYouTube": "View All on YouTube",
  "home.noSermonsAvailable": "No sermons available at the moment.",
  "home.ourChurch": "Our Coptic Orthodox Church",
  "home.churchLeadersDesc": "Led by faithful servants dedicated to spiritual guidance",
  "home.learnMoreAboutUs": "Learn More About Us",
  "home.subscribeNewsletter": "Subscribe to our newsletter for updates on services, events, and spiritual reflections from our community",
  "home.stayConnectedNewsletter": "Stay Connected",
  "home.monthlyNewsletter": "Monthly Newsletter",
  "home.viewAllNewsletters": "View All Newsletters",
  "home.firstName": "First Name",
  "home.emailAddress": "Email Address",
  "home.subscribeBtn": "Subscribe to Newsletter",
  "home.subscribing": "Subscribing...",
  "home.subscribeSuccess": "Thank you for subscribing! You'll receive our updates soon.",
  "home.subscribeError": "Something went wrong. Please try again.",
  "home.privacyNote": "We respect your privacy. Unsubscribe at any time.",
  "home.ourServices": "Our Services",
  "home.servicesDesc": "Learn how our church serves you through worship, teaching, and community care",
  "home.exploreServices": "Explore Our Services",
  "home.moreComingSoon": "More coming soon",
  "home.yourGenerosity": "Your Generosity Makes a Difference",
  "home.supportMission": "Support Our",
  "home.mission": "Mission",
  "home.donateDesc": "Your generous contributions help us continue our ministry, support community programs, and spread God's love to those in need.",
  "home.taxDeductible": "All donations are tax-deductible and processed securely",
  "home.giveNow": "Give Now",
  "home.recurringGift": "Set Up Recurring Gift",
  "home.securePayment": "Secure Payment",
  "home.sslEncrypted": "SSL Encrypted",
  "home.taxReceipt": "Tax Receipt Provided",
  "home.ministryPrograms": "Ministry Programs",
  "home.ministryProgramsDesc": "Supporting worship services, youth programs, and spiritual growth initiatives",
  "home.communityOutreach": "Community Outreach",
  "home.communityOutreachDesc": "Helping those in need through food banks, shelters, and support services",
  "home.missionWork": "Mission Work",
  "home.missionWorkDesc": "Spreading the gospel and serving communities around the world",
  "home.ancientFaith": "Ancient Faith",
  "home.copticTradition": "Coptic Tradition",
  "home.montreal": "Montreal",
  "home.copticHeritage": "Our Coptic Heritage",
  "home.years2000": "2000+ Years",
  "home.apostolicChurch": "Apostolic Church",
  "home.livingTradition": "Living Tradition",
  "home.symbolOfFaith": "Symbol of our faith",
  "home.copticCross": "The Coptic Cross",
  "home.sacredTraditions": "Our Sacred Traditions",
  "home.divineLiturgy": "Divine Liturgy",
  "home.divineLiturgyDesc": "Our liturgy, composed by Saint Basil and Saint Gregory, has been celebrated unchanged for centuries. The Divine Liturgy is the heart of Coptic worship, filled with hymns, prayers, and ancient rituals that connect us to the early Church.",
  "home.copticHymns": "Coptic Hymns",
  "home.copticHymnsDesc": "Our unique musical tradition preserves melodies believed to originate from ancient Egyptian temple music. These sacred hymns, sung in Coptic and Arabic, create a deeply spiritual atmosphere during worship.",
  "home.fastingFeasts": "Fasting & Feasts",
  "home.fastingFeastsDesc": "The Coptic Church observes over 210 days of fasting annually, following ancient ascetic practices. Our liturgical calendar is rich with feasts celebrating the Virgin Mary, saints, and major events in salvation history.",
  "home.iconography": "Iconography",
  "home.iconographyDesc": "Coptic icons are windows to heaven, depicting Christ, the Virgin Mary, and saints in the distinctive Byzantine-Egyptian style. These sacred images are integral to our worship and spiritual life.",
  "home.monasticism": "Monasticism",
  "home.monasticismDesc": "Egypt is the birthplace of Christian monasticism. Saints Anthony and Pachomius established the monastic tradition that continues to inspire our spiritual life, emphasizing prayer, fasting, and service.",
  "home.copticLanguage": "Coptic Language",
  "home.copticLanguageDesc": "The Coptic language, the final stage of ancient Egyptian, is preserved in our liturgy. It connects us directly to the language spoken in Egypt during the time of Christ and the early Church fathers.",
  "home.loveCompassion": "Love & Compassion",
  "home.loveCompassionDesc": "Following Christ's commandment to love one another, we show God's love through acts of kindness, compassion, and genuine care for our community and all people.",
  "home.community": "Community",
  "home.communityDesc": "Building meaningful relationships rooted in faith, supporting each other through life's journey in a warm, welcoming environment that honors our Coptic heritage.",
  "home.service": "Service",
  "home.serviceDesc": "Making a positive impact through outreach programs, volunteer work, and serving those in need with dedication, following the example of our patron saints.",
  "home.upcoming": "Upcoming",
  "home.joinFellowship": "Join Us in Fellowship",
  "home.learnMore": "Learn More",
  "home.getInTouch": "Get in Touch",
  "home.address": "Address",
  "home.phone": "Phone",
  "home.email": "Email",
  "home.officeHours": "Office Hours",
  "home.officeHoursValue": "Monday - Friday: 9:00 AM - 5:00 PM\nSaturday: 10:00 AM - 2:00 PM",
  "home.sendMessage": "Send Message",
  "home.sending": "Sending...",
  "home.thankYou": "Thank you! We'll get back to you soon.",
  "home.namePlaceholder": "Your full name",
  "home.emailPlaceholder": "your.email@example.com",
  "home.phonePlaceholder": "(555) 123-4567",
  "home.messagePlaceholder": "How can we help you?",
  "home.message": "Message",
  "home.newsletter.january": "January Newsletter",
  "home.newsletter.december": "December Newsletter",
  "home.newsletter.november": "November Newsletter",
  "home.newsletter.october": "October Newsletter",
  "home.newsletter.janDesc": "New year blessings, upcoming events, and ministry updates",
  "home.newsletter.decDesc": "Christmas celebrations, year in review, and gratitude",
  "home.newsletter.novDesc": "Thanksgiving reflections and community highlights",
  "home.newsletter.octDesc": "Fall activities and ministry opportunities",
  "home.newsletter.janDate": "January 2025",
  "home.newsletter.decDate": "December 2024",
  "home.newsletter.novDate": "November 2024",
  "home.newsletter.octDate": "October 2024",

  // ── Home Events Component ──
  "home.events.upcoming": "Upcoming",
  "home.events.communityOutreach": "Community Outreach Day",
  "home.events.communityOutreachDesc": "Join us in serving our local community with food distribution and support services.",
  "home.events.youthGathering": "Youth Group Gathering",
  "home.events.youthGatheringDesc": "Fun activities, worship, and fellowship for teens and young adults.",
  "home.events.marriageWorkshop": "Marriage Enrichment Workshop",
  "home.events.marriageWorkshopDesc": "Strengthen your relationship with practical tools and biblical wisdom.",
  "home.events.movieNight": "Family Movie Night",
  "home.events.movieNightDesc": "Bring the whole family for a fun evening with popcorn and fellowship.",
  "home.events.learnMore": "Learn More →",

  // ── Home CopticCalendar Component ──
  "home.calendar.liturgicalSchedule": "Liturgical Schedule",
  "home.calendar.thisWeek": "This Week at Our Church",
  "home.calendar.thisWeekDesc": "Stay connected with our weekly services, feast days, and community gatherings",
  "home.calendar.sundayLiturgy": "Sunday Liturgy",
  "home.calendar.sundayLiturgyDesc": "Divine Liturgy every Sunday from 8:00 AM to 11:30 AM with English and Arabic hymns.",
  "home.calendar.saturdayVespers": "Saturday Vespers",
  "home.calendar.saturdayVespersDesc": "Evening prayers and Tasbeha (Midnight Praises) every Saturday evening.",
  "home.calendar.bibleStudy": "Bible Study",
  "home.calendar.bibleStudyDesc": "Weekly Bible study and spiritual discussions every Wednesday evening.",
  "home.calendar.viewFullCalendar": "View Full Calendar & Feast Days",

  // ── Home AboutUs Component ──
  "home.about.copticHeritage": "Our Coptic Heritage",
  "home.about.ancientFaith": "Ancient Faith",
  "home.about.copticTradition": "Coptic Tradition",
  "home.about.montreal": "Montreal",
  "home.about.years2000": "2000+ Years",
  "home.about.apostolicChurch": "Apostolic Church",
  "home.about.livingTradition": "Living Tradition",
  "home.about.heritageIntro1": "The Coptic Orthodox Church traces its roots to Saint Mark the Apostle, who brought Christianity to Egypt in the first century AD. For over 2,000 years, our Church has preserved the ancient apostolic faith, maintaining unbroken traditions of worship, liturgy, and spiritual practice.",
  "home.about.heritageIntro2": "Our church is named after two pillars of Coptic spirituality: Saint Mina, the miraculous martyr and protector, and Pope Cyril VI, the modern saint known for his holiness and miracles. We bring this rich heritage to Montreal's North Shore, offering a spiritual home where ancient faith meets contemporary life.",
  "home.about.sacredTraditions": "Our Sacred Traditions",
  "home.about.divineLiturgy": "Divine Liturgy",
  "home.about.divineLiturgyDesc": "Our liturgy, composed by Saint Basil and Saint Gregory, has been celebrated unchanged for centuries. The Divine Liturgy is the heart of Coptic worship, filled with hymns, prayers, and ancient rituals that connect us to the early Church.",
  "home.about.copticHymns": "Coptic Hymns",
  "home.about.copticHymnsDesc": "Our unique musical tradition preserves melodies believed to originate from ancient Egyptian temple music. These sacred hymns, sung in Coptic and Arabic, create a deeply spiritual atmosphere during worship.",
  "home.about.fastingFeasts": "Fasting & Feasts",
  "home.about.fastingFeastsDesc": "The Coptic Church observes over 210 days of fasting annually, following ancient ascetic practices. Our liturgical calendar is rich with feasts celebrating the Virgin Mary, saints, and major events in salvation history.",
  "home.about.iconography": "Iconography",
  "home.about.iconographyDesc": "Coptic icons are windows to heaven, depicting Christ, the Virgin Mary, and saints in the distinctive Byzantine-Egyptian style. These sacred images are integral to our worship and spiritual life.",
  "home.about.monasticism": "Monasticism",
  "home.about.monasticismDesc": "Egypt is the birthplace of Christian monasticism. Saints Anthony and Pachomius established the monastic tradition that continues to inspire our spiritual life, emphasizing prayer, fasting, and service.",
  "home.about.copticLanguage": "Coptic Language",
  "home.about.copticLanguageDesc": "The Coptic language, the final stage of ancient Egyptian, is preserved in our liturgy. It connects us directly to the language spoken in Egypt during the time of Christ and the early Church fathers.",
  "home.about.loveCompassion": "Love & Compassion",
  "home.about.loveCompassionDesc": "Following Christ's commandment to love one another, we show God's love through acts of kindness, compassion, and genuine care for our community and all people.",
  "home.about.community": "Community",
  "home.about.communityDesc": "Building meaningful relationships rooted in faith, supporting each other through life's journey in a warm, welcoming environment that honors our Coptic heritage.",
  "home.about.service": "Service",
  "home.about.serviceDesc": "Making a positive impact through outreach programs, volunteer work, and serving those in need with dedication, following the example of our patron saints.",

  // ── Home Contact Component ──
  "home.contact.getInTouch": "Get in Touch",
  "home.contact.address": "Address",
  "home.contact.addressValue": "123 Faith Avenue\nSpringfield, IL 62701",
  "home.contact.phone": "Phone",
  "home.contact.phoneValue": "(555) 123-4567",
  "home.contact.email": "Email",
  "home.contact.emailValue": "contact@smpcvi.ca",
  "home.contact.officeHours": "Office Hours",
  "home.contact.officeHoursValue": "Monday - Friday: 9:00 AM - 5:00 PM\nSaturday: 10:00 AM - 2:00 PM",
  "home.contact.name": "Name",
  "home.contact.namePlaceholder": "Your full name",
  "home.contact.emailPlaceholder": "your.email@example.com",
  "home.contact.phonePlaceholder": "(555) 123-4567",
  "home.contact.message": "Message",
  "home.contact.messagePlaceholder": "How can we help you?",
  "home.contact.sendMessage": "Send Message",
  "home.contact.sending": "Sending...",
  "home.contact.thankYou": "Thank you! We'll get back to you soon.",
  "home.contact.privacyNote": "We respect your privacy and will never share your information.",

  // ── About Page ──
  "aboutPage.title": "About Us",
  "aboutPage.subtitle": "Learn about our church, our history, and our faith",
  "aboutPage.ourMission": "Our Mission",
  "aboutPage.servingNorthShore": "Serving the North Shore of Montreal",
  "aboutPage.servingNorthShoreDesc1": "St. Mina & Pope Cyril VI Coptic Orthodox Church was established with a divine mission: to serve the spiritual needs of Orthodox Christians living on the North Shore of Montreal. Our church is a spiritual home for families in Laval, Sainte-Thérèse, Blainville, Rosemère, Boisbriand, Mirabel, and all surrounding communities.",
  "aboutPage.servingNorthShoreDesc2": "Through the blessing of His Holiness Pope Tawadros II, we bring the ancient Coptic Orthodox faith to this region, offering the Holy Liturgy, sacraments, spiritual guidance, and a loving community for all who seek Christ.",
  "aboutPage.strategicLocation": "Strategic Location",
  "aboutPage.strategicLocationDesc": "Centrally located in Sainte-Thérèse to serve the entire North Shore region",
  "aboutPage.growingCommunity": "Growing Community",
  "aboutPage.growingCommunityDesc": "Welcoming families from Laval, Blainville, Mirabel, and beyond",
  "aboutPage.ourServiceArea": "Our Service Area",
  "aboutPage.serviceAreaList": "Laval • Sainte-Thérèse • Blainville • Rosemère • Boisbriand • Mirabel • Terrebonne • and more",
  "aboutPage.ourJourney": "Our Journey",
  "aboutPage.churchTimeline": "Church Timeline",
  "aboutPage.timelineDesc": "Founded in 2016 with the blessing of His Holiness Pope Tawadros II, our church has grown from a small community into a thriving spiritual home, marked by expanding families, ongoing renovations, and a shared vision for the future",
  "aboutPage.viewTimeline": "View Our Timeline",
  "aboutPage.hideTimeline": "Hide Timeline",
  "aboutPage.collapseTimeline": "Collapse Timeline",
  "aboutPage.yearsOfFaith": "2,000 Years of Faith",
  "aboutPage.copticChurchTitle": "The Coptic Orthodox Church",
  "aboutPage.copticChurchDesc": "One of the oldest Christian churches in the world, founded by St. Mark the Evangelist in Alexandria, Egypt",
  "aboutPage.churchFounded": "Church Founded",
  "aboutPage.faithfulWorldwide": "Faithful Worldwide",
  "aboutPage.popesOfAlexandria": "Popes of Alexandria",
  "aboutPage.fastingDays": "Fasting Days/Year",
  "aboutPage.heavenlyIntercessors": "Heavenly Intercessors",
  "aboutPage.patronSaints": "Our Patron Saints",
  "aboutPage.patronSaintsDesc": "The saints who guide and intercede for our church community",
  "aboutPage.spiritualGuidance": "Spiritual Guidance",
  "aboutPage.spiritualFathers": "Our Spiritual Fathers",
  "aboutPage.spiritualFathersDesc": "The Pope, Bishop, and Priest who shepherd our community in faith",
  "aboutPage.churchBoard": "Church Board Members",
  "aboutPage.churchBoardDesc": "Dedicated servants leading our parish administration",
  "aboutPage.ourMissionTitle": "Our Mission",
  "aboutPage.ourMissionDesc": "To proclaim the Gospel of Jesus Christ, preserve the apostolic faith and Coptic traditions, and serve the spiritual needs of Orthodox Christians on the North Shore of Montreal through worship, education, fellowship, and community outreach.",
  "aboutPage.ourVision": "Our Vision",
  "aboutPage.ourVisionDesc": "To be a beacon of Orthodox Christian faith on the North Shore, growing as a vibrant parish that nurtures spiritual growth, welcomes all seekers of Christ, and serves as a home for generations of faithful families.",
  "aboutPage.missionCelebrate": "Celebrate the Holy Liturgy and Sacraments",
  "aboutPage.missionTeach": "Teach and preserve Coptic Orthodox traditions",
  "aboutPage.missionCommunity": "Build a loving, supportive community",
  "aboutPage.visionExpand": "Expand our facilities to serve more families",
  "aboutPage.visionYouth": "Develop youth and family ministries",
  "aboutPage.visionOutreach": "Strengthen community outreach programs",
  "aboutPage.joinFamily": "Join Our Church Family",
  "aboutPage.joinFamilyDesc": "We welcome you to worship with us and become part of our growing community",
  "aboutPage.viewServiceTimes": "View Service Times",

  // ── About Page Timeline Events ──
  "aboutPage.timeline.2016.title": "The Beginning",
  "aboutPage.timeline.2016.desc": "The community started expanding in the North Shore of Montreal, through the request of Pope Tawadros II. He sent Father Anthony to start the church under Saint Mina and Pope Cyril VI. Through the prayers of the wonderworker Saint Mina and the blessed Saint Cyril VI, less than a month after the Pope's request, we found a church for sale and were able to purchase it. The first liturgy was celebrated in November on the day of the commemoration of St. Mina.",
  "aboutPage.timeline.2017.title": "Renovations Begin",
  "aboutPage.timeline.2017.desc": "Renovations started in the basement and the church upstairs, transforming the building into a beautiful place of worship for our growing community.",
  "aboutPage.timeline.2018.title": "Father Anthony's 10th Anniversary",
  "aboutPage.timeline.2018.desc": "We celebrated the 10th anniversary of Father Anthony as a priest, honoring his dedicated service to the Coptic Orthodox Church.",
  "aboutPage.timeline.2019.title": "Bishop Boulos Ordained",
  "aboutPage.timeline.2019.desc": "Pope Tawadros II ordained Father Boulos el Baramousy to Bishop Boulos for the Diocese of Ottawa, Montreal and Eastern Canada.",
  "aboutPage.timeline.2024.title": "Iconostasis Project",
  "aboutPage.timeline.2024.desc": "The project started for the iconostasis of the church, a sacred screen adorned with icons that will enhance our liturgical worship.",
  "aboutPage.timeline.2025.title": "Exterior Renovation",
  "aboutPage.timeline.2025.desc": "We started the renovation outside of the church, beautifying the exterior to reflect the glory of God and welcome our community.",
  "aboutPage.timeline.2026.title": "10th Anniversary Celebration",
  "aboutPage.timeline.2026.desc": "We celebrate the 10th anniversary of our church, a decade of faith, growth, and service to the North Shore community.",

  // ── About Page Coptic History ──
  "aboutPage.copticHistory.origins.title": "The Name \"Egypt\" & Coptic Heritage",
  "aboutPage.copticHistory.origins.era": "Origins",
  "aboutPage.copticHistory.origins.desc": "The word \"Coptic\" comes from the Greek \"Aigyptos,\" which derives from \"Ha-Ka-Ptah\" (House of the Spirit of Ptah), the ancient name for Memphis. Copts are the indigenous Christians of Egypt, direct descendants of the ancient Pharaonic civilization who embraced Christianity.",
  "aboutPage.copticHistory.stMark.title": "St. Mark the Evangelist",
  "aboutPage.copticHistory.stMark.desc": "Saint Mark, author of the second Gospel, brought Christianity to Egypt around 42 AD. He established the Church of Alexandria, ordained the first bishop, and founded the famous Catechetical School. He was martyred in 68 AD, and his relics remain in St. Mark's Cathedral in Cairo.",
  "aboutPage.copticHistory.councils.title": "Ecumenical Councils & Theology",
  "aboutPage.copticHistory.councils.era": "Councils",
  "aboutPage.copticHistory.councils.desc": "Coptic theologians played crucial roles in the early Church councils. At Nicaea (325 AD), St. Athanasius defended Christ's divinity against Arianism. At Ephesus (431 AD), St. Cyril defended Mary as Theotokos (Mother of God). After Chalcedon (451 AD), the Coptic Church maintained its Miaphysite Christology.",
  "aboutPage.copticHistory.beliefs.title": "What We Believe",
  "aboutPage.copticHistory.beliefs.era": "Beliefs",
  "aboutPage.copticHistory.beliefs.desc": "We believe in One God: Father, Son, and Holy Spirit. We confess that Jesus Christ is fully God and fully man, united in one nature (Miaphysite). We honor the Virgin Mary as Theotokos, venerate the saints, practice the seven sacraments, and follow apostolic succession through our Popes of Alexandria.",
  "aboutPage.copticHistory.traditions.title": "What Makes Us Special",
  "aboutPage.copticHistory.traditions.era": "Traditions",
  "aboutPage.copticHistory.traditions.desc": "The Coptic Church preserves the Coptic language (last stage of ancient Egyptian) in liturgy. We are the birthplace of Christian monasticism through St. Anthony and St. Pachomius. Our liturgy, hymns, and fasting traditions (over 210 days annually) remain unchanged for nearly 2,000 years.",
  "aboutPage.copticHistory.today.title": "A Living Ancient Faith",
  "aboutPage.copticHistory.today.era": "Today",
  "aboutPage.copticHistory.today.desc": "Today, over 20 million Copts worldwide continue this apostolic faith. From Egypt to Montreal, we maintain the same liturgy St. Mark established, the same hymns from ancient Egypt, and the same unwavering faith that sustained countless martyrs throughout history.",

  // About Page Saints
  "aboutPage.saints.stMina.name": "St. Mina the Wonderworker",
  "aboutPage.saints.stMina.title": "Patron Saint",
  "aboutPage.saints.stMina.desc": "Egyptian martyr and miracle worker, one of the most beloved saints. Our church is named in his honor and was established on his feast day.",
  "aboutPage.saints.stMina.feast": "November 24",
  "aboutPage.saints.popeCyril.name": "Pope Cyril VI",
  "aboutPage.saints.popeCyril.title": "Patron Saint",
  "aboutPage.saints.popeCyril.desc": "The 116th Pope of Alexandria, known for his holiness, miracles, and deep spirituality. Our church is named in his honor and blessed by his intercessions.",
  "aboutPage.saints.popeCyril.feast": "March 9",

  // About Page Leadership
  "aboutPage.leadership.popeTawadros.name": "H.H. Pope Tawadros II",
  "aboutPage.leadership.popeTawadros.title": "Pope of Alexandria",
  "aboutPage.leadership.popeTawadros.desc": "The 118th Pope of Alexandria and Patriarch of the See of St. Mark. His Holiness leads the worldwide Coptic Orthodox Church with wisdom and grace.",
  "aboutPage.leadership.bishopBoulos.name": "H.G. Bishop Boulos",
  "aboutPage.leadership.bishopBoulos.title": "Bishop of Ottawa, Montreal & Eastern Canada",
  "aboutPage.leadership.bishopBoulos.desc": "His Grace Bishop Boulos el Baramousy was ordained in 2019 by Pope Tawadros II to oversee the Diocese of Ottawa, Montreal and Eastern Canada, providing spiritual guidance to our parish.",
  "aboutPage.leadership.frAnthony.name": "Fr. Anthony Micheal",
  "aboutPage.leadership.frAnthony.title": "Parish Priest",
  "aboutPage.leadership.frAnthony.desc": "Father Anthony serves as the dedicated parish priest of St. Mina & Pope Cyril VI Church, shepherding our community with love and devotion since being sent by Pope Tawadros II in 2016.",

  // Services Page
  "servicesPage.title": "Worship Services",
  "servicesPage.subtitle": "Join us in worship and spiritual growth",
  "servicesPage.whatWeOffer": "What We Offer",
  "servicesPage.ministriesPrograms": "Ministries & Programs",
  "servicesPage.ministriesDesc": "Our church offers a variety of services and ministries to help you grow in faith, connect with community, and serve others in Christ's name.",
  "servicesPage.getInvolved": "Get Involved",
  "servicesPage.getInvolvedDesc": "We invite you to join one of our ministries and use your God-given talents to serve the church and community. There's a place for everyone!",
  "servicesPage.joinFormTitle": "Join Us or Request More Information",
  "servicesPage.joinFormDesc": "Select a service and we'll get back to you.",
  "servicesPage.fullNameLabel": "Full Name",
  "servicesPage.yourName": "Your name",
  "servicesPage.emailLabel": "Email",
  "servicesPage.youExample": "you@example.com",
  "servicesPage.phoneLabel": "Phone",
  "servicesPage.serviceInterested": "Service I'm Interested In",
  "servicesPage.selectService": "Select a service...",
  "servicesPage.messageOpt": "Message",
  "servicesPage.messageOptDesc": "Any questions or details...",
  "servicesPage.maxChars": "Maximum 500 characters",
  "servicesPage.submitRequest": "Submit Request",

  // ── Services Detail Data ──
  "services.bibleStudy.title": "Bible Study",
  "services.bibleStudy.schedule": "Every Saturday, 5:00 PM",
  "services.bibleStudy.location": "Church Classrooms",
  "services.bibleStudy.desc": "Deepen your understanding of Holy Scripture through our weekly Bible Study sessions. Led by our clergy and experienced teachers, these gatherings explore the Old and New Testaments, the writings of the Church Fathers, and how to apply biblical wisdom to daily life.",
  "services.bibleStudy.feature1": "Verse-by-verse study",
  "services.bibleStudy.feature2": "Group discussions",
  "services.bibleStudy.feature3": "Q&A sessions",
  "services.bibleStudy.feature4": "Study materials provided",

  "services.hymnsClass.title": "Hymns Class",
  "services.hymnsClass.schedule": "Every Saturday, 7:00 PM",
  "services.hymnsClass.location": "Church Classrooms",
  "services.hymnsClass.desc": "Learn the beautiful and ancient Coptic hymns that have been passed down through generations. Our Hymns Class teaches the traditional melodies, pronunciation, and spiritual meaning behind each hymn, preserving our rich liturgical heritage.",
  "services.hymnsClass.feature1": "Coptic language instruction",
  "services.hymnsClass.feature2": "Traditional melodies",
  "services.hymnsClass.feature3": "Hymn history & meaning",
  "services.hymnsClass.feature4": "All skill levels welcome",

  "services.sundaySchool.title": "Sunday School",
  "services.sundaySchool.schedule": "Every Sunday, 12:30 PM",
  "services.sundaySchool.location": "Church Classrooms",
  "services.sundaySchool.desc": "Our Sunday School program provides faith education for children and youth of all ages. Through engaging lessons, activities, and discussions, young members learn about the Bible, Coptic traditions, saints' lives, and how to live as faithful Christians.",
  "services.sundaySchool.feature1": "Age-appropriate classes",
  "services.sundaySchool.feature2": "Interactive lessons",
  "services.sundaySchool.feature3": "Arts & crafts activities",
  "services.sundaySchool.feature4": "Annual competitions",

  "services.youthMeeting.title": "Youth Meeting",
  "services.youthMeeting.schedule": "Every Friday, 8:30 PM",
  "services.youthMeeting.location": "Church Basement",
  "services.youthMeeting.desc": "A vibrant community for young adults to grow in faith together. Our Youth Meeting combines spiritual discussions, fellowship activities, and service opportunities. It's a safe space to ask questions, build friendships, and strengthen your relationship with God.",
  "services.youthMeeting.feature1": "Spiritual discussions",
  "services.youthMeeting.feature2": "Social activities",
  "services.youthMeeting.feature3": "Service projects",
  "services.youthMeeting.feature4": "Retreats & trips",

  "services.familyMeeting.title": "Family Meeting",
  "services.familyMeeting.schedule": "Every Friday, 8:30 PM",
  "services.familyMeeting.location": "Pope Cyril's Hallway",
  "services.familyMeeting.desc": "Strengthen family bonds through faith with our monthly Family Meeting. Parents and children come together for spiritual guidance, parenting discussions, and family activities that help build Christ-centered homes.",
  "services.familyMeeting.feature1": "Family worship",
  "services.familyMeeting.feature2": "Parenting guidance",
  "services.familyMeeting.feature3": "Children's activities",
  "services.familyMeeting.feature4": "Fellowship dinner",

  "services.seniorsMeeting.title": "Seniors Meeting",
  "services.seniorsMeeting.schedule": "Every Thursday, 11:00 AM",
  "services.seniorsMeeting.location": "Parish Hall",
  "services.seniorsMeeting.desc": "A cherished gathering for our senior members to enjoy fellowship, spiritual enrichment, and community support. The Seniors Meeting includes prayer, health discussions, social activities, and opportunities to share wisdom with younger generations.",
  "services.seniorsMeeting.feature1": "Prayer & devotion",
  "services.seniorsMeeting.feature2": "Health seminars",
  "services.seniorsMeeting.feature3": "Social activities",
  "services.seniorsMeeting.feature4": "Lunch provided",

  "services.churchChoirs.title": "Church Choirs",
  "services.churchChoirs.schedule": "Practice: Saturdays, 4:00 PM",
  "services.churchChoirs.location": "Church Sanctuary",
  "services.churchChoirs.desc": "Our Church Choirs lead the congregation in sacred worship through beautiful Coptic hymns and responses. We have choirs for different age groups, from children to adults, all dedicated to glorifying God through music.",
  "services.churchChoirs.feature1": "Adult choir",
  "services.churchChoirs.feature2": "Youth choir",
  "services.churchChoirs.feature3": "Children's choir",
  "services.churchChoirs.feature4": "Special occasions",

  "services.theatreService.title": "Theatre Service",
  "services.theatreService.schedule": "Seasonal Performances",
  "services.theatreService.location": "Church Hall",
  "services.theatreService.desc": "Our Theatre Ministry brings scripture and the lives of the saints to life through powerful dramatic performances. From Christmas and Easter plays to educational skits for Sunday School, our talented members use the arts to inspire faith and deepen spiritual understanding.",
  "services.theatreService.feature1": "Biblical plays",
  "services.theatreService.feature2": "Saints' life dramas",
  "services.theatreService.feature3": "Youth performances",
  "services.theatreService.feature4": "Holiday productions",

  "services.itMedia.title": "IT & Media Services",
  "services.itMedia.schedule": "Ongoing Support",
  "services.itMedia.location": "Media Room",
  "services.itMedia.desc": "Our IT & Media team ensures our church stays connected with the community through technology. From live-streaming services to managing our website and social media, this team helps spread the Gospel using modern tools.",
  "services.itMedia.feature1": "Live streaming",
  "services.itMedia.feature2": "Website management",
  "services.itMedia.feature3": "Social media",
  "services.itMedia.feature4": "Audio/visual support",

  "services.kitchenServices.title": "Kitchen Services",
  "services.kitchenServices.schedule": "Sundays & Special Events",
  "services.kitchenServices.location": "Church Kitchen",
  "services.kitchenServices.desc": "Our Kitchen Services team prepares meals for fellowship after liturgy and special church events. This ministry of hospitality brings the community together around the table, continuing the tradition of breaking bread together.",
  "services.kitchenServices.feature1": "Sunday agape meals",
  "services.kitchenServices.feature2": "Event catering",
  "services.kitchenServices.feature3": "Fasting menu options",
  "services.kitchenServices.feature4": "Volunteer opportunities",

  "services.holyBread.title": "Holy Bread Services",
  "services.holyBread.schedule": "Saturdays, Early Morning",
  "services.holyBread.location": "Bread Preparation Room",
  "services.holyBread.desc": "The Holy Bread (Korban) service is a sacred ministry where volunteers prepare the bread used for Holy Communion. This ancient tradition requires prayer, fasting, and devotion as the bread is baked with special prayers and hymns.",
  "services.holyBread.feature1": "Sacred preparation",
  "services.holyBread.feature2": "Traditional methods",
  "services.holyBread.feature3": "Prayer & hymns",
  "services.holyBread.feature4": "Training available",

  "services.cleaningServices.title": "Cleaning Services",
  "services.cleaningServices.schedule": "Weekly & As Needed",
  "services.cleaningServices.location": "Entire Church Campus",
  "services.cleaningServices.desc": "Our Cleaning Services team maintains the beauty and sanctity of God's house. These dedicated volunteers ensure our church, halls, and grounds are clean and welcoming for all who enter to worship.",
  "services.cleaningServices.feature1": "Church sanctuary care",
  "services.cleaningServices.feature2": "Hall maintenance",
  "services.cleaningServices.feature3": "Grounds keeping",
  "services.cleaningServices.feature4": "Event setup/cleanup",

  "services.homelessServices.title": "Homeless Services",
  "services.homelessServices.schedule": "Monthly Outreach",
  "services.homelessServices.location": "Community Outreach",
  "services.homelessServices.desc": "Following Christ's call to serve the least among us, our Homeless Services ministry provides food, clothing, and support to those in need. We organize regular outreach events and partner with local shelters to make a difference.",
  "services.homelessServices.feature1": "Food distribution",
  "services.homelessServices.feature2": "Clothing drives",
  "services.homelessServices.feature3": "Shelter partnerships",
  "services.homelessServices.feature4": "Care packages",

  "services.libraryService.title": "Library Service",
  "services.libraryService.schedule": "Open Sundays & By Request",
  "services.libraryService.location": "Church Library",
  "services.libraryService.desc": "Our Church Library offers a wealth of spiritual resources including books on Orthodox theology, saints' lives, Coptic history, children's materials, and multimedia resources. Borrow materials to deepen your faith journey.",
  "services.libraryService.feature1": "Theological books",
  "services.libraryService.feature2": "Children's section",
  "services.libraryService.feature3": "Audio/video resources",
  "services.libraryService.feature4": "Study materials",

  // News Page
  "newsPage.title": "News",
  "newsPage.subtitle": "Stay updated with events, posts, and newsletters from our community",
  "newsPage.articles": "Articles",
  "newsPage.events": "Events",
  "newsPage.posts": "Posts",
  "newsPage.newsletters": "Newsletters",
  "newsPage.upcomingEvents": "Upcoming Events",
  "newsPage.eventsDesc": "Join us for fellowship, worship, and community activities",
  "newsPage.latestPosts": "Latest Posts",
  "newsPage.postsDesc": "Reflections, announcements, and stories from our church community",
  "newsPage.readMore": "Read More",
  "newsPage.monthlyNewsletters": "Monthly Newsletters",
  "newsPage.newslettersDesc": "Download our monthly newsletters to stay informed about church activities",
  "newsPage.downloadPDF": "Download PDF",
  "newsPage.newsletter1Title": "January Newsletter",
  "newsPage.newsletter1Desc": "New year blessings, upcoming events, and ministry updates",
  "newsPage.newsletter2Title": "December Newsletter",
  "newsPage.newsletter2Desc": "Christmas celebrations, year in review, and gratitude",
  "newsPage.newsletter3Title": "November Newsletter",
  "newsPage.newsletter3Desc": "Thanksgiving reflections and community highlights",
  "newsPage.newsletter4Title": "October Newsletter",
  "newsPage.newsletter4Desc": "Fall activities and ministry opportunities",
  "newsPage.subscribeNewsletter": "Subscribe to Our Newsletter",
  "newsPage.subscribeDesc": "Receive monthly updates directly in your inbox",
  "newsPage.emailPlaceholder": "Enter your email",
  "newsPage.subscribe": "Subscribe",
  "newsPage.viewAllOnInstagram": "View All Posts on Instagram",
  "newsPage.seasonalPosts": "Seasonal Posts",
  "newsPage.seasonalPostsDesc": "In-depth reflections on the seasons and celebrations of the Coptic Orthodox liturgical year",
  "newsPage.socialMedia": "Social Media",
  "newsPage.socialMediaDesc": "Stay connected with our latest moments, reflections, and community highlights.",
  "newsPage.monthlyUpdates": "Monthly Updates",
  "newsPage.currentlyObserving": "Currently Observing",
  "newsPage.currentSeason": "Current Season",
  "newsPage.nextFeast": "Next Feast",
  "newsPage.nextFast": "Next Fast",
  "newsPage.days": "Days",
  "newsPage.now": "Now",
  "newsPage.fastingObserved": "Fasting observed",
  "newsPage.backToArticles": "Back to Articles",
  "newsPage.fastingGuidelines": "Fasting Guidelines",
  "newsPage.exploreCalendar": "Explore our complete church schedule — weekly services, feast days, fasting periods, and special events throughout the Coptic liturgical year.",

  // Calendar Page
  "calendarPage.title": "Calendar",
  "calendarPage.subtitle": "Feast days, fasting periods, and weekly services",
  "calendarPage.weeklySchedule": "Weekly Schedule",
  "calendarPage.thisWeekServices": "This Week's Services",
  "calendarPage.weeklyScheduleDesc": "Stay connected with our weekly services, feast days, and community gatherings",
  "calendarPage.liturgicalYear": "Liturgical Year",
  "calendarPage.feastDaysFasting": "Feast Days & Fasting",
  "calendarPage.liturgicalYearDesc": "The Coptic Orthodox Church follows an ancient liturgical calendar rich with feasts, commemorations, and fasting periods that have been observed for over 2,000 years.",
  "calendarPage.tab.all": "All",
  "calendarPage.tab.major": "7 Major Feasts",
  "calendarPage.tab.minor": "7 Minor Feasts",
  "calendarPage.tab.fast": "Fasting Periods",
  "calendarPage.stats.majorFeasts": "Major Feasts of the Lord",
  "calendarPage.stats.minorFeasts": "Minor Feasts of the Lord",
  "calendarPage.stats.fastingDays": "Days of Fasting Per Year",
  "calendarPage.majorInfoTitle": "The 7 Major Feasts",
  "calendarPage.majorInfoDesc": "are the most important celebrations in the Coptic liturgical year. They commemorate the key events in the life of Christ and are preceded by special fasting and preparation. These feasts are celebrated with great solemnity and joy.",
  "calendarPage.minorInfoTitle": "The 7 Minor Feasts",
  "calendarPage.minorInfoDesc": "complement the Major Feasts by commemorating other significant events in the life of Christ and the Virgin Mary. They are celebrated with liturgical services and special hymns, enriching the spiritual life of the faithful throughout the year.",
  "calendarPage.fastInfoTitle": "Fasting in the Coptic Church",
  "calendarPage.fastInfoDesc": "is one of the most ancient Christian practices. The Coptic Orthodox Church observes over 210 days of fasting per year — more than any other Christian denomination. Fasting involves abstaining from all animal products and is accompanied by increased prayer and spiritual discipline.",
  "calendarPage.category.major": "Major Feast",
  "calendarPage.category.minor": "Minor Feast",
  "calendarPage.category.fast": "Fasting Period",
  "calendarPage.spiritualSignificance": "Spiritual Significance",
  "calendarPage.stayUpdated": "Stay Updated",
  "calendarPage.stayUpdatedDesc": "Keep up with the latest church news, events, sermons, and community updates. Our news page is regularly updated with stories, announcements, and reflections from our church family.",
  "calendarPage.goToNews": "Go to News",
  "calendarPage.viewFullCalendar": "View Full Calendar",
  "calendarPage.goToCalendar": "Go to Calendar",
  "calendarPage.aboutCopticCalendar": "About the Coptic Calendar",
  "calendarPage.calendarInfo": "The Coptic calendar begins on September 11 (Nayrouz) and consists of 13 months. Moveable feasts like Easter follow the Julian calendar. Dates shown are in the Gregorian calendar. For specific dates each year, please check our weekly bulletin or contact the church office.",

  // Contact Page
  "contactPage.title": "Contact Us",
  "contactPage.subtitle": "We'd love to hear from you",
  "contactPage.getInTouch": "Get in Touch",
  "contactPage.address": "Address",
  "contactPage.phone": "Phone",
  "contactPage.email": "Email",
  "contactPage.findUs": "Find Us",
  "contactPage.name": "Name",
  "contactPage.namePlaceholder": "Your full name",
  "contactPage.emailPlaceholder": "your.email@example.com",
  "contactPage.phonePlaceholder": "(514) 123-4567",
  "contactPage.message": "Message",
  "contactPage.messagePlaceholder": "How can we help you?",
  "contactPage.sendMessage": "Send Message",
  "contactPage.sending": "Sending...",
  "contactPage.thankYou": "Thank you! We'll get back to you soon.",
  "contactPage.privacyNote": "We respect your privacy and will never share your information.",
  "contactPage.leadership": "Leadership",
  "contactPage.resourcesCTA": "Explore our collection of church forms, digital apps, answers to common questions, library materials, and official brand assets.",
  "contactPage.goToResources": "Go to Resources",

  // Donate Page
  "donatePage.title": "Support Our Mission",
  "donatePage.subtitle": "Your generosity makes a difference in our community",
  "donatePage.supportMission": "Support Our",
  "donatePage.mission": "Mission",
  "donatePage.donateDesc": "Your generous contributions help us continue our ministry, support community programs, and spread God's love to those in need.",
  "donatePage.taxDeductible": "All donations are tax-deductible and processed securely",
  "donatePage.giveNow": "Give Now",
  "donatePage.giveMonthly": "Give Monthly",
  "donatePage.recurringGift": "Set Up Recurring Gift",
  "donatePage.oneTime": "One-time",
  "donatePage.monthly": "Monthly",
  "donatePage.monthlyGift": "Select a Monthly Amount",
  "donatePage.whyMonthly": "Why give monthly?",
  "donatePage.monthlyImpact": "Monthly gifts provide steady, reliable support that helps us plan ahead, sustain our ministries year-round, and respond quickly to community needs. Even a small recurring donation makes a lasting difference.",
  "donatePage.securePayment": "Secure Payment",
  "donatePage.sslEncrypted": "SSL Encrypted",
  "donatePage.taxReceipt": "Tax Receipt Provided",
  "donatePage.ministryPrograms": "Ministry Programs",
  "donatePage.ministryProgramsDesc": "Supporting worship services, youth programs, and spiritual growth initiatives",
  "donatePage.communityOutreach": "Community Outreach",
  "donatePage.communityOutreachDesc": "Helping those in need through food banks, shelters, and support services",
  "donatePage.missionWork": "Mission Work",
  "donatePage.missionWorkDesc": "Spreading the gospel and serving communities around the world",
  "donatePage.otherWaysToGive": "Other Ways to Give",
  "donatePage.giveWithPayPal": "PayPal",
  "donatePage.giveWithPayPalDesc": "Donate securely online using your PayPal account or credit card.",
  "donatePage.openPayPal": "Donate with PayPal",
  "donatePage.registeredCharity": "Registered Canadian Charity",
  "donatePage.charityNumber": "Official donation receipts provided for tax purposes",
  "donatePage.taxReceiptsWillBeIssued": "Official tax receipts will be issued for all donations",
  "donatePage.interacTransfer": "Interac e-Transfer",
  "donatePage.interacDesc": "Send your e-transfer directly from your Canadian bank account.",
  "donatePage.interacEmail": "Send to",
  "donatePage.interacQuestion": "Security Question",
  "donatePage.interacAnswer": "Answer",
  "donatePage.interacTaxNote": "Please include your full name, address, phone, and email in the message for tax receipt purposes.",
  "donatePage.mailCheck": "Mail a Check",
  "donatePage.mailCheckDesc": "Make checks payable to \"Saint Mina & Pope Cyril VI Church\" and mail to our church address.",
  "donatePage.inKindDonations": "In-Kind Donations",
  "donatePage.inKindDonationsDesc": "We accept donations of goods and services. Contact us to learn about current needs.",
  "donatePage.paypalSecure": "Secure checkout via PayPal",
  "donatePage.close": "Close",
  "donatePage.legacyGiving": "Legacy Giving",
  "donatePage.legacyGivingDesc": "Include our church in your estate planning to leave a lasting impact.",
  "donatePage.bibleVerse": "Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver.",
  "donatePage.bibleVerseRef": "2 Corinthians 9:7",
  "donatePage.selectAmount": "Select an Amount",
  "donatePage.customAmount": "Custom Amount",
  "donatePage.enterAmount": "Enter amount",

  // Sermons Page
  "sermonsPage.title": "Sermons",
  "sermonsPage.subtitle": "Inspiring messages from our clergy",
  "sermons.loading": "Loading sermons...",
  "sermons.viewAll": "View All",
  "sermons.watchOnYouTube": "Watch on YouTube",
  "sermons.noVideos": "No videos available",

  // Calendar Feasts Data
  "feast.nativity.name": "Nativity of Christ (Christmas)",
  "feast.nativity.date": "January 7 (29 Kiahk)",
  "feast.nativity.desc": "The celebration of the birth of our Lord and Savior Jesus Christ in Bethlehem from the Virgin Mary.",
  "feast.nativity.significance": "One of the most joyful feasts of the year. Preceded by the 43-day Advent fast, the Nativity marks the Incarnation of God — the Word becoming flesh to dwell among us and bring salvation to all mankind.",
  "feast.theophany.name": "Theophany (Epiphany)",
  "feast.theophany.date": "January 19 (11 Tobi)",
  "feast.theophany.desc": "Commemorates the baptism of Jesus Christ in the Jordan River by St. John the Baptist.",
  "feast.theophany.significance": "At this moment, the Holy Trinity was fully revealed: the Father's voice was heard, the Son was baptized, and the Holy Spirit descended as a dove. Coptic churches bless water on this day.",
  "feast.annunciation.name": "Annunciation",
  "feast.annunciation.date": "April 7 (29 Baramhat)",
  "feast.annunciation.desc": "The Archangel Gabriel announces to the Virgin Mary that she will conceive and bear the Son of God.",
  "feast.annunciation.significance": "This feast marks the moment of the Incarnation — when the Virgin Mary said \"Let it be to me according to your word\" (Luke 1:38). Celebrated exactly nine months before the Nativity.",
  "feast.palmSunday.name": "Palm Sunday",
  "feast.palmSunday.date": "Moveable — Sunday before Easter",
  "feast.palmSunday.desc": "Christ's triumphant entry into Jerusalem, welcomed by crowds waving palm branches.",
  "feast.palmSunday.significance": "Palm Sunday opens Holy Week (Pascha Week), the most sacred week of the Coptic year. Palms are blessed and distributed. It fulfills the prophecy of Zechariah 9:9.",
  "feast.resurrection.name": "Resurrection (Easter / Holy Pascha)",
  "feast.resurrection.date": "Moveable — follows Julian calendar",
  "feast.resurrection.desc": "The glorious resurrection of our Lord Jesus Christ from the dead on the third day.",
  "feast.resurrection.significance": "The greatest and most important feast of the entire Christian year. After 55 days of Great Lent and Holy Week, the Church erupts in joy: \"Christ is Risen — Truly He is Risen!\"",
  "feast.ascension.name": "Ascension of Christ",
  "feast.ascension.date": "40 days after Easter (Thursday)",
  "feast.ascension.desc": "Christ ascends bodily into heaven forty days after His Resurrection, in the presence of His disciples.",
  "feast.ascension.significance": "The Ascension confirms Christ's glorified humanity is now seated at the right hand of the Father. It prepares disciples for the coming of the Holy Spirit.",
  "feast.pentecost.name": "Pentecost (Descent of the Holy Spirit)",
  "feast.pentecost.date": "50 days after Easter (Sunday)",
  "feast.pentecost.desc": "The Holy Spirit descends upon the Apostles in the Upper Room as tongues of fire, empowering them to preach.",
  "feast.pentecost.significance": "Pentecost is considered the birthday of the Church. The disciples received the gift of the Holy Spirit and began speaking in many languages, fulfilling Christ's promise.",
  "feast.circumcision.name": "Circumcision of Christ",
  "feast.circumcision.date": "January 14 (6 Tobi)",
  "feast.circumcision.desc": "Commemorates the circumcision of the infant Jesus on the eighth day after His birth, according to Jewish law.",
  "feast.circumcision.significance": "Christ submitted to the Law of Moses to fulfill it on our behalf. This feast reminds us of His full humanity and His obedience to the Father.",
  "feast.presentation.name": "Entry into the Temple (Presentation)",
  "feast.presentation.date": "February 15 (8 Amshir)",
  "feast.presentation.desc": "The presentation of the infant Jesus at the Temple in Jerusalem, forty days after His birth.",
  "feast.presentation.significance": "Simeon and Anna recognized the infant Christ as the Messiah. Simeon's prayer is sung at every Coptic Compline service.",
  "feast.holyFamily.name": "Entry of the Holy Family into Egypt",
  "feast.holyFamily.date": "June 1 (24 Bashans)",
  "feast.holyFamily.desc": "Commemorates the flight of the Holy Family into Egypt to escape King Herod.",
  "feast.holyFamily.significance": "Egypt holds a unique place in Coptic identity: the Holy Family blessed Egyptian soil by their presence, fulfilling the prophecy \"Out of Egypt I called My Son\".",
  "feast.transfiguration.name": "Transfiguration of Christ",
  "feast.transfiguration.date": "August 19 (13 Misra)",
  "feast.transfiguration.desc": "Christ is transfigured on Mount Tabor, revealing His divine glory to Peter, James, and John.",
  "feast.transfiguration.significance": "The Transfiguration gives a glimpse of Christ's divine nature. Moses and Elijah appear alongside Him. The Father's voice confirms: \"This is My beloved Son, hear Him\".",
  "feast.dormition.name": "Assumption of the Virgin Mary",
  "feast.dormition.date": "August 22 (16 Misra)",
  "feast.dormition.desc": "Commemorates the departure and assumption of the Theotokos (God-bearer), the Virgin Mary.",
  "feast.dormition.significance": "Preceded by the 15-day St. Mary's Fast, this feast honors the Virgin Mary's passing and glorification. The Coptic Church holds the Theotokos in the highest veneration.",
  "feast.crossExaltation.name": "Feast of the Holy Cross",
  "feast.crossExaltation.date": "September 27 (17 Tout)",
  "feast.crossExaltation.desc": "Commemorates the discovery of the True Cross by Empress Helena in 326 AD.",
  "feast.crossExaltation.significance": "The Cross is the central symbol of salvation. This feast celebrates the instrument of our redemption being found and venerated.",
  "feast.nayrouz.name": "Coptic New Year (Nayrouz)",
  "feast.nayrouz.date": "September 11 (1 Tout)",
  "feast.nayrouz.desc": "The first day of the Coptic calendar year, also known as the Feast of the Martyrs.",
  "feast.nayrouz.significance": "Nayrouz honors thousands of Egyptian Christian martyrs. Red dates and red roses symbolize the blood of the martyrs. A day of both celebration and solemn remembrance.",
  "feast.greatLent.name": "Great Lent (Holy 55-Day Fast)",
  "feast.greatLent.date": "55 days before Easter",
  "feast.greatLent.desc": "The holiest and most important fasting period of the Coptic year, preparing the faithful for Holy Pascha.",
  "feast.greatLent.significance": "Great Lent consists of 40 days plus Holy Week. A time of intense prayer, fasting, repentance, and spiritual renewal. Faithful abstain from all animal products.",
  "feast.adventFast.name": "Advent Fast (Christmas Fast)",
  "feast.adventFast.date": "November 25 – January 6 (43 days)",
  "feast.adventFast.desc": "A 43-day fast preparing the faithful for the Nativity of Christ.",
  "feast.adventFast.significance": "The Advent fast begins November 25 and ends January 6. A time of spiritual preparation and reflection on the Incarnation.",
  "feast.apostlesFast.name": "Apostles' Fast",
  "feast.apostlesFast.date": "After Pentecost — variable length",
  "feast.apostlesFast.desc": "A fast honoring the Holy Apostles, beginning the Monday after Pentecost Sunday.",
  "feast.apostlesFast.significance": "This fast commemorates the Apostles' fasting after receiving the Holy Spirit as they prepared to preach the Gospel. Ends on the Feast of Saints Peter and Paul (July 12).",
  "feast.stMaryFast.name": "St. Mary's Fast",
  "feast.stMaryFast.date": "August 7–21 (15 days)",
  "feast.stMaryFast.desc": "A 15-day fast in honor of the Virgin Mary, the Theotokos, preceding her Assumption feast.",
  "feast.stMaryFast.significance": "This fast expresses the Church's deep love for the Virgin Mary. It concludes with the joyful Feast of the Assumption on August 22.",
  "feast.nineveh.name": "Fast of Nineveh",
  "feast.nineveh.date": "3 days — Monday to Wednesday, 3 weeks before Great Lent",
  "feast.nineveh.desc": "A three-day fast commemorating the repentance of the people of Nineveh at the preaching of the Prophet Jonah.",
  "feast.nineveh.significance": "This fast reminds us of God's mercy and the power of repentance. Many Copts fast completely for the three days.",
  "feast.wedFri.name": "Wednesday & Friday Weekly Fast",
  "feast.wedFri.date": "Every Wednesday and Friday year-round",
  "feast.wedFri.desc": "The Coptic Church fasts every Wednesday and Friday throughout the year.",
  "feast.wedFri.significance": "Wednesday commemorates the betrayal of Christ. Friday commemorates the Crucifixion. Observed by abstaining from animal products until the ninth hour (3 PM).",

  // Resources Page
  "resourcesPage.title": "Resources",
  "resourcesPage.subtitle": "Forms, libraries, and tools for our church community",
  "resourcesPage.quickAccess": "Quick Access",
  "resourcesPage.churchForms": "Church Forms",
  "resourcesPage.formsDesc": "Access official church forms for sacraments, events, and membership",
  "resourcesPage.membershipForm": "Membership Form",
  "resourcesPage.membershipFormDesc": "Join our parish community officially",
  "resourcesPage.baptismForm": "Baptism Form",
  "resourcesPage.baptismFormDesc": "Request the sacrament of Holy Baptism",
  "resourcesPage.engagementForm": "Engagement Form",
  "resourcesPage.engagementFormDesc": "Register your engagement ceremony",
  "resourcesPage.weddingForm": "Wedding Form",
  "resourcesPage.weddingFormDesc": "Schedule and register your marriage ceremony",
  "resourcesPage.funeralForm": "Funeral Form",
  "resourcesPage.funeralFormDesc": "Arrange funeral and memorial services",
  "resourcesPage.eventBooking": "Event Booking",
  "resourcesPage.eventBookingDesc": "Reserve church halls and spaces for events",
  "resourcesPage.accessForm": "Access Form",
  "resourcesPage.dioceseService": "Diocese Service",
  "resourcesPage.copticAnswersTitle": "Coptic Orthodox Answers",
  "resourcesPage.copticAnswersDesc": "A comprehensive resource by the Diocese of Ottawa, Montreal and Eastern Canada providing answers to common questions about the Coptic Orthodox faith, theology, and traditions.",
  "resourcesPage.faithQuestions": "Faith Questions",
  "resourcesPage.faithQuestionsDesc": "Get clear answers to common questions about Coptic Orthodox beliefs",
  "resourcesPage.theologicalTopics": "Theological Topics",
  "resourcesPage.theologicalTopicsDesc": "Explore deep theological subjects explained by our clergy",
  "resourcesPage.videoResources": "Video Resources",
  "resourcesPage.videoResourcesDesc": "Watch educational videos about the Coptic faith and traditions",
  "resourcesPage.visitCopticAnswers": "Visit Coptic Orthodox Answers",
  "resourcesPage.learnGrow": "Learn & Grow",
  "resourcesPage.librariesTitle": "Spiritual Libraries",
  "resourcesPage.librariesDesc": "Explore our collection of books, hymns, and study materials",
  "resourcesPage.popeShenoudaBooks": "Pope Shenouda III Books",
  "resourcesPage.popeShenoudaBooksDesc": "Spiritual writings and teachings from Pope Shenouda III",
  "resourcesPage.releaseOfSpirit": "Release of the Spirit",
  "resourcesPage.lifeOfFaith": "Life of Repentance and Purity",
  "resourcesPage.contemplations": "Contemplations on Psalms",
  "resourcesPage.wordsOfBenefit": "Words of Spiritual Benefit",
  "resourcesPage.hymnalResources": "Hymnal Resources",
  "resourcesPage.hymnalResourcesDesc": "Coptic hymn books and liturgical music resources",
  "resourcesPage.copticHymnsBook": "Coptic Hymns Book",
  "resourcesPage.tasbehaLyrics": "Tasbeha Lyrics",
  "resourcesPage.liturgyResponses": "Liturgy of St. Basil",
  "resourcesPage.seasonalHymns": "Seasonal Hymns",
  "resourcesPage.bibleStudyMaterials": "Bible Study Materials",
  "resourcesPage.bibleStudyMaterialsDesc": "Study guides and commentaries for scripture study",
  "resourcesPage.oldTestament": "Old Testament Study",
  "resourcesPage.newTestament": "New Testament Study",
  "resourcesPage.psalmsCommentary": "Psalms Commentary",
  "resourcesPage.churchFathers": "Church Fathers",
  "resourcesPage.sundaySchoolCurriculum": "Sunday School Curriculum",
  "resourcesPage.sundaySchoolCurriculumDesc": "Age-appropriate faith formation materials for all grades",
  "resourcesPage.preKMaterials": "Pre-K Materials",
  "resourcesPage.elementaryLessons": "Elementary Lessons",
  "resourcesPage.youthStudies": "Youth Studies",
  "resourcesPage.adultFormation": "Adult Formation",
  "resourcesPage.brandAssets": "Brand Assets",
  "resourcesPage.logoAndFonts": "Logo & Fonts",
  "resourcesPage.logoAndFontsDesc": "Official church logos and Coptic fonts for use in church materials",
  "resourcesPage.churchLogo": "Church Logo",
  "resourcesPage.fullColorLogo": "Full Color Logo",
  "resourcesPage.primaryUse": "Primary use — light backgrounds",
  "resourcesPage.downloadPNG": "Download PNG",
  "resourcesPage.whiteLogo": "White Logo",
  "resourcesPage.darkBackgrounds": "For dark backgrounds",
  "resourcesPage.monochromeLogo": "Monochrome Logo",
  "resourcesPage.printMaterials": "Print materials",
  "resourcesPage.iconOnly": "Icon Only",
  "resourcesPage.outlineLightLogo": "Outline Light",
  "resourcesPage.outlineLightDesc": "For dark backgrounds",
  "resourcesPage.outlineDarkLogo": "Outline Dark",
  "resourcesPage.outlineDarkDesc": "For light backgrounds",
  "resourcesPage.copticFonts": "Coptic Fonts",
  "resourcesPage.copticFontsTitle": "Official Coptic Font Pack",
  "resourcesPage.copticFontsSubtitle": "For Windows & Mac",
  "resourcesPage.copticFontsDesc": "Download the official Coptic fonts used in our liturgical materials, Sunday School resources, and church publications.",
  "resourcesPage.downloadFontPack": "Download Font Pack (.zip)",
  "resourcesPage.installationGuide": "Installation Guide",
  "resourcesPage.installationGuideTitle": "How to Install Coptic Fonts",
  "resourcesPage.installationGuideWindows": "Windows",
  "resourcesPage.installationGuideMac": "Mac",
  "resourcesPage.installationGuideStep1": "Download the font pack ZIP file",
  "resourcesPage.installationGuideStep2": "Extract/unzip the downloaded file",
  "resourcesPage.installationGuideStep3Win": "Right-click each .ttf or .otf file → Install",
  "resourcesPage.installationGuideStep3Mac": "Double-click each .ttf or .otf file → Install Font",
  "resourcesPage.installationGuideStep4": "Restart your application (Word, etc.) to use the fonts",
  "resourcesPage.sampleText": "Coptic text sample — Christ is Risen",
  "resourcesPage.fontsIncluded": "Fonts included in this pack:",
  "resourcesPage.usageGuidelines": "Usage Guidelines",
  "resourcesPage.usageGuidelinesDesc": "These assets are for official church use only. Please maintain the integrity of the logos and use approved fonts in all church publications.",
  "resourcesPage.needHelp": "Need Help?",
  "resourcesPage.needHelpDesc": "If you have questions about church forms, resources, or need assistance, our team is here to help.",

  // Language
  "language": "Language",

  // Weekly Calendar Component
  "weeklyCalendar.servicesEvents": "Services & Events Schedule",
  "weeklyCalendar.subscribe": "Subscribe",
  "weeklyCalendar.googleCalendar": "Google Calendar",
  "weeklyCalendar.today": "Today",
  "weeklyCalendar.thisWeekSchedule": "This Week's Schedule",
  "weeklyCalendar.viewAllWeek": "View all week",
  "weeklyCalendar.loadingEvents": "Loading events...",
  "weeklyCalendar.noEvents": "No events scheduled",
  "weeklyCalendar.events": "events",
  "weeklyCalendar.liturgy": "Liturgy",
  "weeklyCalendar.feast": "Feast",
  "weeklyCalendar.fast": "Fast",
  "weeklyCalendar.meeting": "Meeting",
  "weeklyCalendar.youth": "Youth",
  "weeklyCalendar.subscribeShort": "Subscribe",
  "weeklyCalendar.calendar": "Calendar",
};

export default translations;